var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 29 47",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    stroke: "#959AA2",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 44.5,
    rx: 13.5
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M13.103 9.926v9.53"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjlweCIgaGVpZ2h0PSI0N3B4IiB2aWV3Qm94PSIwIDAgMjkgNDciIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDYzLjEgKDkyNDUyKSAtIGh0dHBzOi8vc2tldGNoLmNvbSAtLT4KICAgIDxnIGlkPSJEZXNpZ24tUGFnZXMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJHQS1MYW5kaW5nLU5vbi1Mb2dpbiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTcwNi4wMDAwMDAsIC04MTYuMDAwMDAwKSIgc3Ryb2tlPSIjOTU5QUEyIiBzdHJva2Utd2lkdGg9IjIiPgogICAgICAgICAgICA8ZyBpZD0iU2Nyb2xsLUljb24iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDcwNy4wMDAwMDAsIDgxNy4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMDAwMDAwLCAtMC4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlIiB4PSIwIiB5PSItMy4xMDMzOTk4OWUtMTQiIHdpZHRoPSIyNyIgaGVpZ2h0PSI0NC41IiByeD0iMTMuNSI+PC9yZWN0PgogICAgICAgICAgICAgICAgICAgIDxsaW5lIHgxPSIxMy4xMDI5NDEyIiB5MT0iOS45MjY0NzA1OSIgeDI9IjEzLjEwMjk0MTIiIHkyPSIxOS40NTU4ODI0IiBpZD0iTGluZS01IiBzdHJva2UtbGluZWNhcD0icm91bmQiPjwvbGluZT4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgMouse as ReactComponent };